import React from 'react';

export default function ContentPaperEditIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0847 11.0394L11 16.2565L8.5 16.7693L9 14.2052L14.0873 8.98808C14.3516 8.71655 14.7103 8.56396 15.0843 8.56396C15.4584 8.56396 15.8171 8.71655 16.0813 8.98808L16.0873 8.99355C16.6373 9.55929 16.6361 10.4751 16.0847 11.0394Z"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49731 14.7181H2.49731C1.94503 14.7181 1.49731 14.2589 1.49731 13.6925V2.41041C1.49731 1.84396 1.94503 1.38477 2.49731 1.38477H12.4973C13.0496 1.38477 13.4973 1.84396 13.4973 2.41041V7.02579"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49731 4.46191H10.4973"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49731 7.53857H10.4973"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49731 10.6157H9.49731"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
